export default {"src":"/_next/static/image/public/images/ic_new_card.e89de89c4fa059cb3d2344ef9fc0906d.svg","height":20,"width":28};